import axios from "axios";
import { NEW_API_URL } from "../constants/Globals";

export const isUserHasValidRoleForGroup = async (groupIdVal, roleName) => {
  try {
    let url = '';
    if (roleName.toUpperCase() == "SUPERADMIN") {
      url = `${NEW_API_URL}/master/group/is-valid-role?groupId=0&roleName=${roleName}`;
    } else {
      if (groupIdVal) {
        url = `${NEW_API_URL}/master/group/is-valid-role?groupId=${groupIdVal}&roleName=${roleName}`;
      } else {
        alert("Group required when role is not superadmin.");
        return false;
      }
    }

    const res = await axios.get(url);
    if (res.data.status) {
      return res.data.data.isUserHasValidRoleForGroup ? true: false;
    } else {
      alert("There is a problem in fetching group access detail.");
    }
  } catch (err) {
    alert("There is a problem in fetching group access detail. Please try again!!!!!");
    console.error(err);
  }
}